import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';

import { SPACE_COMFORTABLE, SPACE_COMPACT, SPACE_COZY, colors } from '@/styles';
import { DOT_RADIUS } from '@/components/composed/new-slo-views/expanded/graph/constants';

export const lowEmphasisText = css`
  color: ${token('color.text.subtlest', colors.N200)};
  font-weight: normal;
  font-style: italic;
`;

export const incidentIconStyles = css(`
  font-size: ${DOT_RADIUS * 2}px;
  line-height: 1;
`);

export const tooltipBackground = css`
  padding: ${SPACE_COZY}px;
  padding-top: ${SPACE_COMFORTABLE}px;
`;

export const tooltipResults = css`
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: baseline;
  gap: ${SPACE_COMPACT}px;
  margin-top: ${SPACE_COMPACT}px;

  & h6 {
    margin: 0;
  }
`;

export const captionPrefixStyles = css`
  font-size: 70%;
  font-weight: normal;
`;

export const tooltipIconFixPositionStyls = css`
  span > svg {
    vertical-align: baseline;
  }
`;
